import { deepAccess } from './utils';

export class SortUtils {

  public static propertyComparatorNumber(key: string, direction: 'asc' | 'desc' = 'desc') {
    return (a, b) => {
      const aVal = deepAccess(a, key);
      const bVal = deepAccess(b, key);

      if (aVal < bVal) {
        return direction === 'asc' ? -1 : 1;
      }
      if (aVal > bVal) {
        return direction === 'asc' ? 1 : -1;
      }
      return 0;
    };
  }

  public static propertyComparatorString(key: string) {
    return (a, b) => {
      if (!a[key] && !b[key]) {
        return 0;
      } else {
        if (!a[key]) {
          return -1;
        }
        if (!b[key]) {
          return 1;
        }
      }
      if (a[key].toLowerCase() < b[key].toLowerCase()) {
        return -1;
      }
      if (a[key].toLowerCase() > b[key].toLowerCase()) {
        return 1;
      }
      return 0;
    };
  }

  public static indexComparator() {
    let i = 'index';
    return (a, b) => {


      if (!a[i] && !b[i]) {
        return 0;
      } else {
        if (!a[i]) {
          return -1;
        }
        if (!b[i]) {
          return 1;
        }
      }
      if (a[i] > b[i]) {
        return -1;
      }
      if (a[i] < b[i]) {
        return 1;
      }
      return 0;
    };
  }

  public static keyDescOrder = (a, b): number => {
    return a.key > b.key ? -1 : (b.key > a.key ? 1 : 0);
  }

}
